module.exports = __webpack_public_path__ + "static/media/wind_speed_comparative_per_subpark.6d98edc1.svg";